import type { ElementType } from 'react';
import {
  BellIcon,
  CubeIcon,
  FileTextIcon,
  SparkleIcon,
  StackIcon,
  TargetIcon,
  TrendUpIcon,
} from '@phosphor-icons/react';

import { cn } from '../lib/cn';
import { StatusKind } from './status-kind';

const statusTagMap: Record<
  StatusKind,
  { label: string; bg: string; fg: string; Icon: ElementType }
> = {
  [StatusKind.New]: {
    label: 'NEW',
    bg: 'var(--status-new-bg)',
    fg: 'var(--status-new-text)',
    Icon: CubeIcon,
  },
  [StatusKind.Report]: {
    label: 'REPORT',
    bg: 'var(--status-report-bg)',
    fg: 'var(--status-report-text)',
    Icon: FileTextIcon,
  },
  [StatusKind.Alert]: {
    label: 'ALERT',
    bg: 'var(--status-alert-bg)',
    fg: 'var(--status-alert-text)',
    Icon: BellIcon,
  },
  [StatusKind.Insight]: {
    label: 'INSIGHT',
    bg: 'var(--status-insight-bg)',
    fg: 'var(--status-insight-text)',
    Icon: TrendUpIcon,
  },
  [StatusKind.Recommend]: {
    label: 'RECOMMENDATION',
    bg: 'var(--status-recommend-bg)',
    fg: 'var(--status-recommend-text)',
    Icon: TargetIcon,
  },
  [StatusKind.Ai]: {
    label: 'AI ACTIVITY',
    bg: 'var(--status-ai-bg)',
    fg: 'var(--status-ai-text)',
    Icon: SparkleIcon,
  },
  [StatusKind.Other]: {
    label: 'OTHER',
    bg: 'var(--status-other-bg)',
    fg: 'var(--status-other-text)',
    Icon: StackIcon,
  },
};

export function StatusTag({ kind, className }: { kind: StatusKind; className?: string }) {
  const { label, bg, fg, Icon } = statusTagMap[kind];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-[3px] font-bold uppercase',
        'text-[10px] tracking-[0.06em]',
        className,
      )}
      style={{ background: bg, color: fg }}
    >
      <Icon size={10} weight="bold" />
      {label}
    </span>
  );
}
